import {platform} from "@/api/platform";
import type {App} from "vue";

interface Activity {
    log(type: string, data: any): void;
}

interface ActivityRequest {
    url: string
    timestamp: number
    type: string
    data?: any
}

export default {
    install(app: App): void {
        const activity: Activity = {
            async log(type: string, data?: any): Promise<void> {

                const request: ActivityRequest = {
                    url: window.location.href,
                    timestamp: Math.floor(Date.now() / 1000),
                    type,
                    data,
                };

                await platform.post("/api/v2/portal/track", request);
            },
        };

        app.provide("$activity", activity);
        app.config.globalProperties.$activity = activity;
    },
};
